import { IUserAccountsAutocompleteOptionProps } from '../UserAccountsAutocomplete.types';

const extractAccountName = (value: string | IUserAccountsAutocompleteOptionProps) => {
  if (typeof value === 'string') {
    return value || '';
  }

  return value?.account_name || '';
};

export default extractAccountName;
